module.exports = __webpack_public_path__ + "media/images/fr_ca/BluePrint Wire 2025 FR-4074dbbd93593d3cd7d42e849cbb9082.png";